import React, { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import "../react-print.css";
import { useForm } from "react-hook-form";
import Lmap from "./Lmap";
import { Button, Grid, Drawer, Container } from "@mui/material";
import {
  getInternManualById,
  postInternManual,
  putInternManual,
  getInternshipRequestById,
} from "../api/crud";
import { useDispatch } from "react-redux";
import { updateSnackbar } from "../redux/action/dataAction";
import { optionsBranch } from "./../data/branch-data";
import { matchOptions } from "./../utils/function";
import { currentYear } from "../data/config";
import {Paper}from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { max } from "lodash";


const FormInternManual = ({ internRequestId }) => {
  const isMobile = useMediaQuery('(max-width:767px)');

  const dispatch = useDispatch();
  const [selectedPosition, setSelectedPosition] = useState([0, 0]);
  const { register, watch, setValue, reset } = useForm();
  const [formData, setFormData] = useState(null);
  const [StudentName, setStudentName] = useState(null);
  const [B_id, set_b_id] = useState(null);
  const [CompanyName, setCompanyName] = useState(null);
  const [cp_id, setCompanyID] = useState(null);
  const [FormDateUpdated, setFormDateUpdated] = useState(null);
  const [FormDateCreated, setFormDateCreated] = useState(null);
  const [LinkMap, setLinkMap] = useState(null);
  const [Location, setlocation] = useState(null);
  const watchValue = watch();
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  console.log({ watchValue, stringify: JSON.stringify(watchValue) });

  useEffect(() => {
    setValue("location.lat", selectedPosition[0]);
    setValue("location.lng", selectedPosition[1]);
  }, [selectedPosition]);

  const getData = (id) => {
    getInternManualById(id)
      .then((resArr) => {
        const res = resArr[0];

        console.log("data", res);

        if (res) {
          const dataJson = JSON.parse(res.manual_data);

          reset(dataJson);
          const { lat, lng, link } = dataJson.location;

          setSelectedPosition([lat, lng]);
          setFormDateCreated(res.date_created);
          setFormDateUpdated(res.date_updated);
          setLinkMap(link);
          setlocation(lat + "," + lng);
          setFormData(res);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getDataInternReq = (id) => {
    getInternshipRequestById(id)
      .then((resArr) => {
        const res = resArr[0];
        // console.log("dataStudent", res);

        if (res) {
          setStudentName(res.st_name);
          set_b_id(res.b_id);
          setCompanyName(res.cp_name);
          setCompanyID(res.cp_id);

          setValue("company.name_th", res.cp_name);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onHandleSubmit = async () => {
    try {
      if (!formData) {
        const params = {
          internRequestId,
          manualData: JSON.stringify(watchValue),
          year: currentYear,
        };

        const res = await postInternManual(params);

        dispatch(
          updateSnackbar({
            open: true,
            content: "Successfully added",
          })
        );
      } else {
        const params = {
          internRequestId,
          manualData: JSON.stringify(watchValue),
        };

        const res = await putInternManual(params);

        dispatch(
          updateSnackbar({
            open: true,
            content: "Successfully updated",
          })
        );
      }
    } catch (err) {
      dispatch(
        updateSnackbar({
          open: true,
          content: "Failed to add",
          severity: "error",
        })
      );
    }
  };

  useEffect(() => {
    if (internRequestId) {
      getDataInternReq(internRequestId);
      getData(internRequestId);
    }
  }, [internRequestId]);

  const displayTogetMapLink = <Drawer anchor="right">Test</Drawer>;

  return (
   
  
    <Container maxWidth='md' disableGutters={isMobile} sx={{ paddingLeft: "1mm"}}
    >
      {/* <Grid container justifyContent="center" alignItems={'center'}> */}
      

      <div
        className="sheet padding-20mm  react-print-container"
        style={{
          color: "black", paddingTop: "15mm",
          backgroundColor: "white",
          borderRadius: "10px",
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",

          zoom: isMobile ? 0.525
           : 1,
          flexShrink: 2,

        }}
        ref={componentRef}
      >

          <div style={{ overflowX: "hidden" }}>
            <div className="mb-2">
              <div className="text-center">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/buu-logo-2.png`}
                  alt="buu logo"
                  width="50px"
                />
              </div>
              <div className="text-center ">
                <div style={{ fontWeight: "bold" }}>
                  แบบแจ้งรายละเอียดการปฏิบัติงานและแผนที่ตั้งสถานประกอบการ
                  
                  <div>
                    Cooperative Education Faculty of Engineering Burapha
                    University
                  </div>
                  <div>*****************************</div>
                </div>
              </div>

              <div>
                {" "}
                (ผู้ให้ข้อมูล : {StudentName} รหัสนิสิต{" "}
                {internRequestId?.substring(0, 8)} สาขาวิชา{" "}
                {matchOptions(optionsBranch, B_id)} )
              </div>
              <div>
                ขอแจ้งรายละเอียดเกี่ยวกับตำแหน่งงาน ลักษณะงาน
                ที่ตั้งสถานประกอบการ และผู้นิเทศงาน ดังนี้{" "}
              </div>
              <div>
                {" "}
                (เพื่อประกอบการเดินทางไปนิเทศงานนิสิตที่ถูกต้อง
                โปรดระบุที่อยู่ตามสถานที่ที่นิสิตปฏิบัติงาน)
              </div>
              <div style={{ fontWeight: "bold" }}>
                1. ชื่อสถานประกอบการ{" "}
                {cp_id && <span class="badge badge-soft-dark" style={{fontSize: "1rem", padding: "0.1rem"}}
                >{cp_id} </span>}
                {"  "}
                {CompanyName}
              </div>
              <div className="text-nowrap">
                (ภาษาไทย)
                <input
                  className="input-form-response"
                  style={{ width: "550px", color: "blue", paddingLeft: "50px" }}
                  {...register("company.name_th")}
                />
              </div>
              <div className="text-nowrap">
                (ภาษาอังกฤษ)
                <input
                  className="input-form-response"
                  style={{ width: "550px", color: "blue", paddingLeft: "32px" }}
                  {...register("company.name_en")}
                />
              </div>
              <div className="mb-2">
                <div className="text-nowrap">
                  <div style={{ fontWeight: "bold" }}>
                    2. ที่อยู่สถานประกอบการ
                  </div>

                  <input
                    className="input-form-response"
                    style={{
                      width: "625px",
                      color: "blue",
                      paddingLeft: "50px",
                    }}
                    {...register("company.address.no")}
                  />
                  {/* <div>
                <span>ซอย</span>
                <input
                  className="input-form-response"
                  style={{ width: "80px" }}
                  {...register("company.address.soi")}
                />
                <span>ถนน</span>
                <input
                  className="input-form-response"
                  style={{ width: "80px" }}
                  {...register("company.address.road")}
                />
                </div> */}
                </div>
                <div className="text-nowrap">
                  <span>ตำบล/แขวง</span>
                  <input
                    className="input-form-response "
                    style={{
                      width: "250px",
                      color: "blue",
                      paddingLeft: "50px",
                    }}
                    {...register("company.address.sub_district")}
                  />
                  <span>อำเภอ/เขต</span>
                  <input
                    className="input-form-response "
                    style={{
                      width: "250px",
                      color: "blue",
                      paddingLeft: "50px",
                    }}
                    {...register("company.address.district")}
                  />
                </div>

                <div className="text-nowrap">
                  <span>จังหวัด</span>
                  <input
                    className="input-form-response"
                    style={{
                      width: "278px",
                      color: "blue",
                      paddingLeft: "75px",
                    }}
                    {...register("company.address.province")}
                  />
                  <span>รหัสไปรษณีย์</span>
                  <input
                    className="input-form-response"
                    style={{
                      width: "235px",
                      color: "blue",
                      paddingLeft: "35px",
                    }}
                    {...register("company.address.postcode")}
                  />
                </div>
                <div className="text-nowrap">
                  <span>โทรศัพท์</span>
                  <input
                    className="input-form-response"
                    style={{
                      width: "200px",
                      color: "blue",
                      paddingLeft: "50px",
                    }}
                    {...register("company.address.tel")}
                  />

                  {/* <span>โทรสาร</span>
                <input
                  className="input-form-response"
                  style={{ width: "100px" }}
                  {...register("address.fax")}
                /> */}

                  <span>Email</span>
                  <input
                    className="input-form-response"
                    style={{
                      width: "350px",
                      color: "blue",
                      paddingLeft: "50px",
                    }}
                    {...register("address.email")}
                  />
                </div>
              </div>
            </div>

            <div className="mb-2">
              <div className="text-nowrap">
                <div style={{ fontWeight: "bold" }}>
                  3. ผู้ได้รับมอบหมายให้ประสานงานกับคณะวิศวกรรมศาสตร์
                  มหาวิทยาลัยบูรพา (ในการนิเทศงานนิสิต และอื่น ๆ){" "}
                </div>

                <span>ชื่อ-นามสกุล</span>
                <input
                  className="input-form-response"
                  style={{ width: "550px", color: "blue", paddingLeft: "50px" }}
                  {...register("person.name")}
                />
              </div>

              <div>
                <div className="text-nowrap">
                  <span>ตำแหน่ง</span>
                  <input
                    className="input-form-response"
                    style={{
                      width: "570px",
                      color: "blue",
                      paddingLeft: "50px",
                    }}
                    {...register("person.position")}
                  />
                </div>
                <div className="text-nowrap">
                  <span>แผนก/ฝ่าย</span>
                  <input
                    className="input-form-response"
                    style={{
                      width: "555px",
                      color: "blue",
                      paddingLeft: "30px",
                    }}
                    {...register("person.department")}
                  />
                </div>
                <div className="text-nowrap">
                  <span>โทรศัพท์</span>
                  <input
                    className="input-form-response"
                    style={{
                      width: "200px",
                      color: "blue",
                      paddingLeft: "50px",
                    }}
                    {...register("person.tel")}
                  />
                  <span>Email</span>
                  <input
                    className="input-form-response"
                    style={{
                      width: "350px",
                      color: "blue",
                      paddingLeft: "50px",
                    }}
                    {...register("person.email")}
                  />
                </div>
              </div>

              <div className="mb-2">
                <div className="text-nowrap" style={{ fontWeight: "bold" }}>
                  4. พนักงานที่ปรึกษา/พี่เลี้ยง
                </div>
                <div className="text-nowrap">
                  <span>ชื่อ-นามสกุล </span>
                  <input
                    className="input-form-response"
                    style={{
                      width: "550px",
                      color: "blue",
                      paddingLeft: "50px",
                    }}
                    {...register("auditor.name")}
                  />
                </div>

                <div className="text-nowrap">
                  <span>ตำแหน่ง</span>
                  <input
                    className="input-form-response"
                    style={{
                      width: "570px",
                      color: "blue",
                      paddingLeft: "50px",
                    }}
                    {...register("auditor.position")}
                  />
                </div>
                <div className="text-nowrap">
                  <span>แผนก/ฝ่าย</span>
                  <input
                    className="input-form-response"
                    style={{
                      width: "555px",
                      color: "blue",
                      paddingLeft: "30px",
                    }}
                    {...register("auditor.department")}
                  />
                </div>

                <div className="text-nowrap">
                  <span>โทรศัพท์</span>
                  <input
                    className="input-form-response"
                    style={{
                      width: "200px",
                      color: "blue",
                      paddingLeft: "50px",
                    }}
                    {...register("auditor.tel")}
                  />

                  <span>Email</span>
                  <input
                    className="input-form-response"
                    style={{
                      width: "350px",
                      color: "blue",
                      paddingLeft: "50px",
                    }}
                    {...register("auditor.fax")}
                  />
                </div>
              </div>

              <div className="mb-2">
                <div style={{ fontWeight: "bold" }}>
                  5. งานที่ได้รับมอบหมายให้นิสิตปฏิบัติ
                </div>
                <div className="text-nowrap">
                  <span>ตำแหน่งงานที่นิสิตปฏิบัติ (Job Position)</span>
                  <div>
                    <input
                      className="input-form-response"
                      style={{
                        width: "625px",
                        color: "blue",
                        paddingLeft: "30px",
                      }}
                      {...register("job.position")}
                    />
                  </div>
                </div>
                <div className="text-nowrap">
                  <span>
                    ลักษณะงานและความรับผิดชอบที่นิสิตปฏิบัติ (Job Description){" "}
                  </span>
                  <div>
                    <input
                      // rows="3"
                      className="input-form-response"
                      style={{ color: "blue", paddingLeft: "30px" }}
                      {...register("job.desc")}
                    />
                  </div>
                </div>
              </div>

              <div className="mb-2">
                <div className="text-nowrap" style={{ fontWeight: "bold" }}>
                  <span>6. ผู้ที่สามารถติดต่อได้ในกรณีฉุกเฉิน</span>
                </div>

                <div>
                  ชื่อ-นามสกุล
                  <input
                    className="input-form-response"
                    style={{
                      width: "300px",
                      color: "blue",
                      paddingLeft: "50px",
                    }}
                    {...register("represent.name")}
                  />
                  <span>โทรศัพท์</span>
                  <input
                    className="input-form-response"
                    style={{
                      width: "200px",
                      color: "blue",
                      paddingLeft: "50px",
                    }}
                    {...register("represent.address.tel")}
                  />
                </div>
              </div>

              <div className="mb-2">
                <div className="text-nowrap" style={{ fontWeight: "bold" }}>
                  <span>7. รายละเอียดที่พักระหว่างปฏิบัติงาน ดังนี้</span>
                </div>

                <div className="text-nowrap">
                  <span> ชื่อหอพัก/ที่พักอาศัย </span>
                  <input
                    className="input-form-response"
                    style={{
                      width: "550px",
                      color: "blue",
                      paddingLeft: "50px",
                    }}
                    {...register("dorm.name")}
                  />
                </div>

                <div className="text-nowrap">
                  <span>ที่อยู่</span>
                  <input
                    className="input-form-response"
                    style={{
                      width: "570px",
                      color: "blue",
                      paddingLeft: "50px",
                    }}
                    {...register("dorm.address.no")}
                  />
                </div>

                <div className="text-nowrap">
                  <span>ตำบล/แขวง</span>
                  <input
                    className="input-form-response"
                    style={{
                      width: "250px",
                      color: "blue",
                      paddingLeft: "50px",
                    }}
                    {...register("dorm.address.sub_district")}
                  />
                  <span>อำเภอ/เขต</span>
                  <input
                    className="input-form-response"
                    style={{
                      width: "250px",
                      color: "blue",
                      paddingLeft: "50px",
                    }}
                    {...register("dorm.address.district")}
                  />
                </div>

                <div className="text-nowrap">
                  <span>จังหวัด</span>
                  <input
                    className="input-form-response"
                    style={{
                      width: "278px",
                      color: "blue",
                      paddingLeft: "50px",
                    }}
                    {...register("dorm.address.province")}
                  />
                  <span>รหัสไปรษณีย์</span>
                  <input
                    className="input-form-response"
                    style={{
                      width: "235px",
                      color: "blue",
                      paddingLeft: "50px",
                    }}
                    {...register("dorm.address.postcode")}
                  />
                </div>

                <div className="text-nowrap">
                  <span>โทรศัพท์</span>
                  <input
                    className="input-form-response"
                    style={{
                      width: "200px",
                      color: "blue",
                      paddingLeft: "50px",
                    }}
                    {...register("dorm.address.tel")}
                  />
                  <span>การเดินทางไปฝึกงาน</span>
                  <input
                    className="input-form-response"
                    style={{
                      width: "350px",
                      color: "blue",
                      paddingLeft: "50px",
                    }}
                    {...register("dorm.address.go2work")}
                  />
                </div>
              </div>

              <div className="mb-2">
                <span style={{ fontWeight: "bold" }}>
                  8.แผนที่แสดงตำแหน่งสถานประกอบการ
                </span>

                <div className="text-nowrap">
                  <span>ลิ้งค์การแชร์จาก GoogleMap</span>
                  <input
                    className="input-form-response"
                    style={{
                      width: "350px",
                      color: "blue",
                      textAlign: "center",
                    }}
                    {...register("location.link")}
                  />

                  <a href={LinkMap} target="_blank">
                    คลิกเพื่อดูบน{" "}
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/images/google-maps.png`}
                      alt="Gmaplogo"
                      width="30px"
                    />
                  </a>
                </div>

                {/* <div>
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/getmaplink.png`}
                  alt="get google map link"
                  width="150px"
                />
               </div> */}

                <div className="text-nowrap">
                  <span>ตำแหน่ง (ละติจูด,ลองจิจูด): </span>

                  <input
                    className="input-form-response"
                    style={{
                      width: "330px",
                      color: "blue",
                      textAlign: "center",
                    }}
                    textAlign={"center"}
                    defaultValue={Location}
                    onChange={(ev) => {
                      if (ev.target.value.includes(",")) {
                        setSelectedPosition(ev.target.value?.split(","));
                      }
                    }}
                  />

                  {/* <span>Longitude: </span>
                  <input
                    className="input-form-response"
                    style={{ width: "250px" }}
                    onChange={(ev)=> setSelectedPosition([selectedPosition[0],ev.target.value ])}
                    value={selectedPosition[1]}


                    
                    // {...register("location.lng")}
                    // onChange={handleChange}
                
                  /> */}
                </div>

                <div>
                  <div style={{ paddingTop: "5mm" }}>
                    <a href={`${process.env.PUBLIC_URL}/assets/images/getmaplink.png`} target="_blank">
                      คลิกเพื่อดูวิธีการได้ลิ้งค์ GooglemMap
                    </a>
                  </div>
                  <div>
                    <a
                      href={`${process.env.PUBLIC_URL}/assets/images/getlocationonmap.png`}
                      target="_blank"
                    >
                      คลิกเพื่อดูวิธีการได้พิกัดละติจูดและลองจิจูดบน GoogleMap
                    </a>
                  </div>

                  <div style={{ paddingTop: "5mm" }}>
                    <Lmap
                      selectedPosition={selectedPosition}
                      setSelectedPosition={setSelectedPosition}
                    />
                  </div>

                  <div style={{ paddingTop: "5mm" }}>
                    Created Date: {FormDateCreated} {"/ Updated Date:"}{" "}
                    {FormDateUpdated}
                  </div>
                  {!formData ? (
                    <form method="post" action="./add-intern-manaul.php">
                      <div style={{ paddingTop: "5mm", color: "red" }}>
                        <input
                          className="d-none"
                          name="intern_request_id"
                          value={internRequestId}
                        />
                        <input
                          className="d-none"
                          name="year"
                          value={currentYear}
                        />
                        <input
                          className="d-none"
                          name="manual_data"
                          value={JSON.stringify(watchValue)}
                        />
                        <Button variant="contained" type="submit">
                          บันทึกและส่งฟอร์ม
                        </Button>{" "}
                        {"<= อย่าลืมกดปุ่มบันทึกและส่งฟอร์ม"}
                      </div>
                    </form>
                  ) : (
                    <div style={{ paddingTop: "10mm", color: "red" }}>
                      <Button variant="contained" onClick={onHandleSubmit}>
                        อัพเดตและส่งฟอร์ม
                      </Button>{" "}
                      {"<= อย่าลืมกดปุ่มอัพเดตและส่งฟอร์ม"}
                    </div>
                  )}
                </div>
              </div>
            </div>
            </div>
            </div>
      
     
      {/* </Grid> */}
      </Container>
    
    
  
  );
};

export default FormInternManual;
